import { Button } from "antd";

import React from "react";

const AntdButton = ({ onClick, className, children, icon }) => {
  return (
    <>
      <Button className={className} onClick={onClick} icon={icon}>
        {children}
      </Button>
    </>
  );
};

export default AntdButton;
